import React, { Component } from 'react';

class FormContact extends Component {
    render() {
        return (
            <div className="col-md-6">
                <div className="themesflat-headings style-2 clearfix">
                    <h2 className="heading">CONTACT US</h2>
                    <div className="sep has-width w80 accent-bg clearfix" />
                    <p className="sub-heading">Are you interested in quality building materials for your project? K.LIZZ Classic Hardware - "WE FLOW WITH QUALITIES". For more information on our products or bulk orders, please contact us.</p>
                </div>
                <div className="themesflat-spacer clearfix" data-desktop={20} data-mobile={20} data-smobile={20} />
                <div className="themesflat-content-box clearfix">
                    <div className="contact-info-box">
                        <h5 className="title">Our Contact Information:</h5>
                        <p><strong>Shop 1:</strong> 0717304599 / 0706494665</p>
                        <p><strong>Shop Main:</strong> 0748221975</p>
                        <p><strong>Lipping Specialist:</strong> 0721992367 (Mon-Sat: 7:00 AM - 6:30 PM)</p>
                        <p><strong>Email:</strong> info@klizzclassichardware.co.ke</p>
                        <p><strong>Facebook:</strong> KLizz Classic</p>
                        <p><strong>Location:</strong> Nairobi, Kenya</p>
                    </div>
                </div>
                <div className="themesflat-spacer clearfix" data-desktop={36} data-mobile={35} data-smobile={35} />
                <div className="themesflat-contact-form style-2 clearfix">
                    <form action="#" method="post" className="form-submit contact-form wpcf7-form">
                        <span className="wpcf7-form-control-wrap your-name">
                            <input type="text" tabIndex={1} id="name" name="name" defaultValue={""} className="wpcf7-form-control"
                                placeholder="Name*" required />
                        </span>
                        <span className="wpcf7-form-control-wrap your-phone">
                            <input type="text" tabIndex={2} id="phone" name="phone" defaultValue={""} className="wpcf7-form-control"
                                placeholder="Phone*" required />
                        </span>
                        <span className="wpcf7-form-control-wrap your-email">
                            <input type="email" tabIndex={3} id="email" name="email" defaultValue={""}
                                className="wpcf7-form-control" placeholder="Your Email*" required />
                        </span>
                        <span className="wpcf7-form-control-wrap your-subject">
                            <input type="text" tabIndex={4} id="subject" name="subject" defaultValue={""}
                                className="wpcf7-form-control" placeholder="Product Inquiry (Optional)" />
                        </span>
                        <span className="wpcf7-form-control-wrap your-message">
                            <textarea name="message" tabIndex={5} cols={40} rows={10} className="wpcf7-form-control wpcf7-textarea"
                                placeholder="Your Message or Product Requirements*" required defaultValue={""} />
                            </span>                                                             
                        <span className="wrap-submit">
                        <input type="submit" defaultValue="SEND MESSAGE" className="submit wpcf7-form-control wpcf7-submit" id="submit" name="submit" />
                        </span>                                                            
                    </form>
                </div>
                <div className="themesflat-spacer clearfix" data-desktop={80} data-mobile={60} data-smobile={60} />
            </div>
        );
    }
}

export default FormContact;